import React, { useEffect, useState } from "react";
import {
  Alert,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Modal,
  ModalBody, ModalHeader,
} from "reactstrap";
import { sendMail } from "../ActionAlertFormContainer/lib/notification/notification";

interface Feedback {
  name: IInput;
  phone: IInput;
  urgency: IInput;
  request: IInput;
  email: IInput;
}

interface IInput {
  value: string;
  error?: string;
}

const SupportSubmissionFormContainer: React.FC = () => {
  const [feedback, setFeedback] = useState<Feedback>({
    name: { value: "" },
    phone: { value: "" },
    urgency: { value: "Normal" },
    request: { value: "" },
    email: { value: "" },
    // emailConfirmation: { value: ""},
  });

  const [isOpen, setIsOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [messageSent, setMessageSent] = useState(false);
  const urgencyOptions = ["Low", "Normal", "High", "Urgent",];

  useEffect(() => {
    const updateIsModalOpen = (event: CustomEvent) => {
      setIsOpen(event.detail);
    }
    window.addEventListener('updateIsModalOpen', updateIsModalOpen);
    return () => {
      window.removeEventListener('updateIsModalOpen', updateIsModalOpen);
    }
  }, []);

  const toggle = () => setDropdownOpen((prevState) => !prevState);

  const handleChange = (
    event: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >
  ) => {
    setFeedback({
      ...feedback,
      [event.target.name]: { value: event.target.value },
    });
  };

  const submitFeedback = (event: React.FormEvent) => {
    event.preventDefault();
    // verify all fields are filled out
    for (let key in feedback) {
      if (feedback[key].value === "") {
        setFeedback({
          ...feedback,
          [key]: { ...feedback[key], error: "This field is required" },
        });
        return;
      }
    }

    // @ts-ignore
    const confirmationEmailInputValue = document.getElementById('confirmationEmail').value;

    const emailData = {
      emailData: {
        confirmationEmail: confirmationEmailInputValue,
        name: feedback.name.value,
        phone: feedback.phone.value,
        urgency: feedback.urgency.value,
        supportRequest: feedback.request.value,
        email: feedback.email.value,
      },
    }
    sendMail(emailData, '/scripts/emailHandler?route=send-support-request').then((response) => {
      if (response.MessageId.length > 0) {
        setMessageSent(true);
      } else {
        console.error(
          "There was an error submitting your support request. Please try again later."
        );
      }
    }).catch((error) => {
      console.error(error);
    }).finally(() => {
      setTimeout(() => {
        setMessageSent(false);
        setIsOpen(false);
      }, 6000);
    });
  };

  function setDropdownValue(option: string) {
    setFeedback({
      ...feedback,
      urgency: { value: option },
    });
  }

  return (
    <Modal
      isOpen={isOpen}
      wrapClassName="blacklight"
      modalClassName="blacklight-modal"
    >
      <ModalHeader style={{ padding: "1rem 0" }}>
        <div className="modal-title">
          <div className="container-fluid">
            <div className="row">
              <div className="col-sm-12">
                <h4 className="modal-title">Support Request</h4>
              </div>
            </div>
          </div>
        </div>
      </ModalHeader>
      <ModalBody style={{ padding: "1rem 0" }}>
        <form onSubmit={submitFeedback}>
          <div style={{ display: "none" }}>
            <label htmlFor="confirmationEmail">Confirmation Email</label>
            <input
              type="email"
              name="confirmationEmail"
              id="confirmationEmail"
              value=""
              onChange={handleChange}
            />
          </div>
          <div className="container-fluid">
            <div className="row">
              <div className="col-sm-6">
                <div className="form-group">
                  <label htmlFor="name">Name</label>
                  <input
                    id="name"
                    name="name"
                    onChange={handleChange}
                    type="text"
                    className={`form-control ${feedback.name.error ? "is-invalid" : ""
                      }`}
                    placeholder="Name"
                  />
                  {feedback.name.error && (
                    <div className="invalid-feedback">
                      {feedback.name.error}
                    </div>
                  )}
                </div>
              </div>
              <div className="col-sm-6">
                <div className="form-group">
                  <label htmlFor="phone">Contact Number</label>
                  <input
                    name="phone"
                    onChange={handleChange}
                    type="tel"
                    className={`form-control ${feedback.phone.error ? "is-invalid" : ""
                      }`}
                    placeholder="Contact number"
                  />
                  {feedback.phone.error && (
                    <div className="invalid-feedback">
                      {feedback.phone.error}
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-6">
                <div className="form-group">
                  <label htmlFor="phone">Email</label>
                  <input
                    name="email"
                    onChange={handleChange}
                    type="email"
                    className={`form-control ${feedback.phone.error ? "is-invalid" : ""
                      }`}
                    placeholder="Email"
                  />
                  {feedback.phone.error && (
                    <div className="invalid-feedback">
                      {feedback.phone.error}
                    </div>
                  )}
                </div>
              </div>
              <div className="col-sm-6">
                <div className="form-group">
                  <Dropdown isOpen={dropdownOpen} toggle={toggle}>
                    <DropdownToggle color='white'
                      caret
                    >{`Select urgency: ${feedback.urgency.value}`}</DropdownToggle>
                    <DropdownMenu>
                      {urgencyOptions.map((option) => {
                        return (
                          <DropdownItem
                            active={feedback.urgency.value === option}
                            key={option}
                            onClick={() => setDropdownValue(option)}
                          >
                            {option}
                          </DropdownItem>
                        );
                      })}
                    </DropdownMenu>
                  </Dropdown>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12">
                <textarea
                  name="request"
                  onChange={handleChange}
                  className={`form-control ${feedback.request.error ? "is-invalid" : ""
                    }`}
                  rows={3}
                  placeholder="Enter your support request or question"
                ></textarea>
                {feedback.request.error && (
                  <div className="invalid-feedback">
                    {feedback.request.error}
                  </div>
                )}
              </div>
            </div>
            <div className="row right mt-3">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-sm-12">
                    <button type="submit" className="btn btn-primary mr-3">
                      Submit
                    </button>
                    <button
                      type="button"
                      className="btn btn-secondary"
                      onClick={() => setIsOpen(false)}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </div>
            {messageSent && (
              <Alert color="success" className="mt-3">
                Thank you! Your ticket has been submitted. An Avannis technical
                support team member will contact you to discuss your question.
              </Alert>
            )}
          </div>
        </form>
      </ModalBody>
    </Modal>
  );
};

export default SupportSubmissionFormContainer;
